import { useState } from 'react'
import moment from 'moment-timezone'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Alert } from 'antd'
import styles from '@Orders/OrderDetailsPage/styles.css'

import Box from '~/core/Box'
import { form5106Modal, htsModalForPartDescription } from '../modals'

import CustomClearanceTimer from './CustomClearanceTimer'

type ClearanceBannerType = {
    openChat?: Function
    alertClassName: string
    checked5106: boolean
    createdAt: string
    allHtsSubmitted?: boolean
}
export default function ClearanceBanner(props: ClearanceBannerType) {
    const [htsModalOpen, toggleHTSModalOpen] = useState(false)
    const [form5106ModalOpen, toggleForm5106ModalOpen] = useState(false)
    const { createdAt } = props
    const htsDueDate = moment(createdAt).add(2, 'days')
    const alertType = 'warning'
    const messageTitle = (
        <Box display="block">
            {createdAt &&
                htsDueDate.isBefore(moment()) &&
                'The shipments in this order may be delayed upon import. Please review the customs information tab below for more information.'}
            {createdAt && !htsDueDate.isBefore(moment()) && (
                <>
                    Please provide the required customs clearance information
                    within <CustomClearanceTimer htsDueDate={htsDueDate} /> to
                    reduce the risk of shipment delays upon importation.
                </>
            )}
            {!createdAt && (
                <Box className={styles.alertHeaderTitle}>
                    Please provide the required customs clearance information at
                    least 2 days prior to the order ship date to avoid your
                    shipment being delayed upon importation.
                </Box>
            )}
        </Box>
    )

    return (
        <>
            <Alert
                message={messageTitle}
                type={alertType}
                showIcon
                icon={<ExclamationCircleOutlined />}
                className={styles.alertWarningStyle}
                style={{
                    marginBottom: '15px',
                }}
            />
            {htsModalForPartDescription(htsModalOpen, () =>
                toggleHTSModalOpen(false),
            )}
            {form5106Modal(form5106ModalOpen, () =>
                toggleForm5106ModalOpen(false),
            )}
        </>
    )
}
